// ============================================
// Subscribe Page Product Toggle
// Swaps the "Customize Your Subscription" buy box between
// Energy Shots and Energy Gummies in place — no navigation.
// Fetches each product's buy box from its alternate view template
// (templates/page.subscribe-*-section.liquid), swaps the subtree,
// then re-initializes the buy-box scripts.
// Loaded only by templates/page.subscribe.liquid.
// ============================================

(function () {
  'use strict';

  var VIEW_URLS = {
    shots: '/pages/subscribe?view=subscribe-shots-section',
    gummies: '/pages/subscribe?view=subscribe-gummies-section'
  };

  // If the fetch/swap fails, fall back to the pre-existing purchase
  // path: the product page with the subscription option preselected.
  var FALLBACK_URLS = {
    shots: '/products/proper-wild-energy-shots?subscribeandsave=true',
    gummies: '/products/proper-wild-gummies-10-pack?subscribeandsave=true'
  };

  var cache = {};
  var inFlight = false;

  function getContainer() {
    return document.getElementById('subscribe-product-swap');
  }

  // The overlay carries a toggle-owned marker class: ajax-cart and the
  // rewards flows use .rewards__loading-overlay too, and removing THEIR
  // overlay would drop the busy interlock mid cart-reconciliation.
  function showSpinner() {
    if (!document.querySelector('.rewards__loading-overlay.subscribe-toggle-overlay')) {
      var overlay = document.createElement('div');
      overlay.className = 'rewards__loading-overlay subscribe-toggle-overlay';
      overlay.innerHTML = "<div class='rewards__loading-spinner'></div>";
      document.body.appendChild(overlay);
    }
  }

  function hideSpinner() {
    document.querySelectorAll('.rewards__loading-overlay.subscribe-toggle-overlay').forEach(function (el) {
      el.parentNode.removeChild(el);
    });
  }

  function updateButtons(productKey) {
    document.querySelectorAll('.subscribe-product-selector .subscribe-product-button').forEach(function (btn) {
      btn.classList.toggle('active', btn.getAttribute('data-id') === productKey);
    });
  }

  function swapIn(productKey, html) {
    var container = getContainer();
    var tpl = document.createElement('template');
    tpl.innerHTML = html;

    // Scripts parsed via innerHTML are inert. Pull out the inline ones
    // (the fragment's window.V2_PRICING publisher) to execute explicitly,
    // and drop src scripts — product-v2.js is already loaded on the page.
    var inlineScripts = Array.prototype.slice.call(tpl.content.querySelectorAll('script:not([src])'));
    inlineScripts.forEach(function (s) { s.parentNode.removeChild(s); });
    tpl.content.querySelectorAll('script[src]').forEach(function (s) { s.parentNode.removeChild(s); });

    // Drop the fragment's stylesheet link too — the page-level copy in
    // page.subscribe.liquid keeps the buy box styled across swaps, and
    // re-inserting an identical link every swap is wasted work.
    tpl.content.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) { l.parentNode.removeChild(l); });

    // Remove-then-insert so the buy box's singleton IDs never exist twice.
    container.innerHTML = '';
    container.appendChild(tpl.content);

    inlineScripts.forEach(function (s) {
      var runner = document.createElement('script');
      runner.textContent = s.textContent;
      document.body.appendChild(runner);
      runner.parentNode.removeChild(runner);
    });

    container.setAttribute('data-active-product', productKey);

    // Re-init order matters: buy-box logic first (reads the fresh
    // V2_PRICING and rebinds the new subtree), then the variant
    // selector machinery, then the reviews badge (external widget,
    // best-effort — an absent API just leaves the badge empty).
    if (window.ProductV2 && typeof window.ProductV2.init === 'function') {
      window.ProductV2.init();
    }
    if (typeof window.initSubscribeOptionSelectors === 'function') {
      window.initSubscribeOptionSelectors(productKey);
    }
    if (window.StampedFn && typeof window.StampedFn.loadBadges === 'function') {
      try { window.StampedFn.loadBadges(); } catch (e) { /* cosmetic only */ }
    }
  }

  function activate(productKey) {
    var container = getContainer();
    if (inFlight || !container) return;
    if (!VIEW_URLS[productKey]) return;
    if (container.getAttribute('data-active-product') === productKey) return;
    // Don't detach a form with a cart response still pending — a 422
    // error arriving after the swap would render into the removed subtree
    // and the shopper would never see it.
    if (document.querySelector('#AddToCart.is-adding')) return;

    // Existing selection analytics (names predate this toggle)
    if (productKey === 'shots') {
      try { if (typeof ga === 'function') ga('send', 'event', 'click', 'gummies_subscription_click'); } catch (e) {}
      try { if (typeof gtag === 'function') gtag('event', 'gummies_subscription_click', {}); } catch (e) {}
    }

    inFlight = true;
    showSpinner();

    var fragmentReady = cache[productKey]
      ? Promise.resolve(cache[productKey])
      : fetch(VIEW_URLS[productKey], { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('Fragment fetch failed: ' + res.status);
            return res.text();
          })
          .then(function (html) {
            // Only cache what is actually a buy-box fragment — a 200 that
            // isn't one (challenge page, error page) must not poison the
            // session cache; throwing routes it to the fallback below.
            if (html.indexOf('AddToCartForm') === -1) {
              throw new Error('Response is not a buy-box fragment');
            }
            cache[productKey] = html;
            return html;
          });

    fragmentReady
      .then(function (html) {
        swapIn(productKey, html);
        updateButtons(productKey);
        inFlight = false;
        hideSpinner();
      })
      .catch(function (err) {
        // A swap/init regression must stay diagnosable — without this log
        // it is indistinguishable from an expected network failure.
        console.error('[subscribe-toggle] swap failed, falling back to product page', err);
        // Keep the spinner up while navigating (matches the old behavior)
        location.href = FALLBACK_URLS[productKey];
      });
  }

  // A bfcache restore (Back after the fallback navigation) revives the page
  // with inFlight still true and the overlay in the DOM — reset both or the
  // toggle stays inert behind a full-page overlay.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      inFlight = false;
      hideSpinner();
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.subscribe-product-selector .subscribe-product-button');
    if (!btn) return;
    activate(btn.getAttribute('data-id'));
  });
})();
